var Flickity = require('flickity');
export const singleClinique = {
  init: function () {  
    var galleryElems = document.querySelectorAll('.bk-carousel-cards .list-grid');

    var mm = window.matchMedia("(max-width: 768px)");
    clinicResponsive(mm);
    mm.addListener(clinicResponsive);

    function clinicResponsive(mm) {
      if (mm.matches) {
        for ( var i=0, len = galleryElems.length; i < len; i++ ) {
          var galleryElem = galleryElems[i];
          var flkty = new Flickity(galleryElem,{      
            autoPlay: false,
            pageDots: false,
            cellAlign: 'center',
            wrapAround: false
          });   
        }
      } else {
        for ( var i=0, len = galleryElems.length; i < len; i++ ) {
          var galleryElem = galleryElems[i];
          var flkty = new Flickity(galleryElem,{      
            contain: true,
            center:true,
            prevNextButtons: true,
            freeScroll: false,
            autoPlay: false,
            pageDots: false,
            selectedAttraction: 0.01,
            friction: 0.15,
            cellAlign: 'left',
            wrapAround: false
          });   
        }
      }
    }


    for ( var i=0, len = galleryElems.length; i < len; i++ ) {
      var galleryElem = galleryElems[i];
      var flkty = new Flickity(galleryElem,{      
        //contain: true,
        //center:true,
        //prevNextButtons: false,
        //freeScroll: true,
        autoPlay: false,
        pageDots: false,
        //selectedAttraction: 0.01,
        //friction: 0.15,
        cellAlign: 'center',
        wrapAround: false
      });   
    }
    var progressBar = document.querySelectorAll('.progress-bar');
    for ( var i=0, len = progressBar.length; i < len; i++ ) { 
      var progressBa = progressBar[i];   
      flkty.on( 'scroll', function( progress ) {
        progress = Math.max( 0, Math.min( 20, progress ) );
        progressBa.style.width = progress * 100 + '%';
      });
    }
      

    // Mini circle revael
    if($('.bk-mini-circle-reveal--container').length) {

      const descHeight = $('.bk-mini-circle-reveal--description').outerHeight();
      console.log('descHeight: ' + descHeight);

      var tl = gsap.timeline();
  
      tl
      .to(
        ".bk-mini-circle-reveal--container",
        {
          width:"100%",
          height: (descHeight + 100) + 'px',
          //backgroundSize: "100%",
        }
        
      )
      .fromTo(
        ".bk-mini-circle-reveal--description h3, .bk-mini-circle-reveal--description p, .bk-mini-circle-reveal--description .wp-block-button",{
          opacity: 0, y:30},
        {
          y:-0,
          opacity: 1,
          stagger: 0.1,
          // pin:true,
  
        },"<.2"
      );
      ScrollTrigger.create({
        trigger: ".bk-mini-circle-reveal",
        id: "sttriggerh",
        start: "top 50%",
        end:"bottom 55%",
        scrub: 1,
        animation: tl,
      })
    }


     
}
};